import Layout from '../Layout'
import PageError from '../../Common/PageError'
import { SilentPageProvider } from '../../../context/silentPageContext'
import { HyperLink } from '../../Common/Form'
import styles from './index.css'

const SellerError = (props) => {
  const {
    code = 404,
    message = '您的連結可能有誤，或您輸入的網址不存在！'
  } = props
  return (
    <Layout isHideUserInfo>
      <div className={styles.errorLayout}>
        <SilentPageProvider defaultValue>
          <PageError
            errorMessage={`${code} ${message}`}
            withErrorMessage
            withImage
          >
            <HyperLink href='/seller/dashboard'>
              回店家儀表板
            </HyperLink>
          </PageError>
        </SilentPageProvider>
      </div>
    </Layout>
  )
}

export default SellerError
